"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,13,22.91,4.59A2.39,2.39,0,0,0,21.6,4.2H2.4a2.38,2.38,0,0,0-1.26.37Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.71,5.49,12.35,14.27a.59.59,0,0,1-.7,0L.31,5.45A2.37,2.37,0,0,0,0,6.6V17.4a2.4,2.4,0,0,0,2.4,2.4H21.6A2.4,2.4,0,0,0,24,17.4V6.6A2.37,2.37,0,0,0,23.71,5.49Z"
  }));
};

exports["default"] = _default;